var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.80481 0.606925C7.00833 -0.0194372 7.89446 -0.0194364 8.09798 0.606926L9.20674 4.01932C9.29775 4.29944 9.55879 4.48909 9.85332 4.48909H13.4413C14.0999 4.48909 14.3738 5.33186 13.8409 5.71897L10.9382 7.82794C10.6999 8.00107 10.6002 8.30793 10.6912 8.58805L11.8 12.0004C12.0035 12.6268 11.2866 13.1477 10.7538 12.7606L7.85101 10.6516C7.61273 10.4785 7.29007 10.4785 7.05178 10.6516L4.14902 12.7605C3.61621 13.1477 2.89931 12.6268 3.10282 12.0004L4.21158 8.58805C4.3026 8.30793 4.20289 8.00107 3.9646 7.82794L1.06185 5.71897C0.529033 5.33186 0.802863 4.48909 1.46146 4.48909H5.04947C5.344 4.48909 5.60504 4.29944 5.69605 4.01932L6.80481 0.606925Z",
    fill: "#FFEA00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFill);
export default __webpack_public_path__ + "static/media/star-fill.1ea20f78486c2888fb34ef5d7dcf5ef0.svg";
export { ForwardRef as ReactComponent };